module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_9.38228e4a.pdf";